import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import { Button, Card, CardBody, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import validationSchema from './VehicleAddBidForm.schema';
import { FormCurrencyInputField } from '../../common/components/formFields';
import DealersSelectField from '../../dealers/forms/DealersSelectField';
import LocationsSelectField from '../../locations/forms/LocationsSelectField';
import { addVehicleBid, searchBids } from '../../bids/BidsActions';
import { parsePriceFormatToInt } from '../../helpers/parsePriceFormatToInt';
import FormSelectField from '../../common/components/formFields/FormSelectField';
import { getAuctionDetails, getDealersEmployees } from '../VehicleActions';
import { dataToSelect } from '../../common/helpers';
import { formatOrganizationLocation } from '../../helpers/formatOrganizationLocation';
import { AuctionStatus } from '../../constants/AuctionStatus';
import { useQueryString } from '../../common/helpers/queryString';

const initialValues = {
  organizationId: '',
  organizationMemberId: '',
  organizationLocationId: null,
  amountInPence: '',
};

let formContext = null;

function VehicleAddBidForm() {
  const dispatch = useDispatch();
  const { id: auctionId } = useParams();
  const query = useQueryString();
  const status = useSelector((state) => state.vehicles.get('auctionDetails'))?.status;
  const isLoading = useSelector((state) => state.bids.get('isLoading'));
  const bids = useSelector((state) => state.bids.get('items'));
  const [employees, setEmployees] = useState([]);

  const findExistingBidLocation = (organizationId) => {
    if (!organizationId) {
      return null;
    }
    const existingBid = (bids || []).find(
      (bid) => bid?.bidder?.organization?.id === organizationId && bid?.bidderLocation?.id,
    );
    if (!existingBid) {
      return null;
    }
    return {
      value: existingBid.bidderLocation.id,
      label: formatOrganizationLocation(existingBid.bidderLocation),
    };
  };

  const [searchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    auctionId: auctionId || null,
  });

  useEffect(() => {
    if (auctionId) {
      dispatch(getAuctionDetails(auctionId));
    }
  }, [dispatch, auctionId]);
  const handleChangeDealer = (employee) => {
    formContext.setFieldValue(
      'organizationLocationId',
      findExistingBidLocation(employee?.value),
    );
    if (employee?.value) {
      dispatch(
        getDealersEmployees(employee?.value, (employees) => {
          setEmployees(dataToSelect(employees, ['id', 'firstName']));
          formContext.setFieldValue('organizationMemberId', {});
        }),
      );
    }
  };

  const handleSubmit = (
    { organizationMemberId, organizationLocationId, amountInPound },
    { setSubmitting },
  ) => {
    dispatch(
      addVehicleBid(
        {
          auctionId,
          organizationMemberId: organizationMemberId?.value,
          organizationLocationId: organizationLocationId?.value,
          amountInPence: parsePriceFormatToInt(amountInPound, false),
        },
        () => dispatch(searchBids(searchParams)),
      ),
    );
    setSubmitting(false);
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnBlur
    >
      {(form) => {
        formContext = form;
        return (
          <Form autoComplete="off">
            <Card>
              <CardBody>
                <Row>
                  <Col md="3">
                    <DealersSelectField
                      name="organizationId"
                      label="Dealer"
                      onChangeHandler={handleChangeDealer}
                      disabled={status !== AuctionStatus.PUBLISHED || isLoading}
                    />
                  </Col>
                  <Col md="3">
                    <FormSelectField
                      name="organizationMemberId"
                      label="User"
                      options={employees}
                      disabled={status !== AuctionStatus.PUBLISHED || isLoading}
                    />
                  </Col>
                  <Col md="3">
                    <LocationsSelectField
                      name="organizationLocationId"
                      label="Location"
                      organizationId={form.values.organizationId?.value || null}
                      disabled={
                        status !== AuctionStatus.PUBLISHED ||
                        isLoading ||
                        !form.values.organizationId?.value ||
                        !!findExistingBidLocation(form.values.organizationId?.value)
                      }
                    />
                  </Col>
                  <Col md="3">
                    <FormCurrencyInputField
                      name="amountInPound"
                      label="Bid"
                      disabled={status !== AuctionStatus.PUBLISHED || isLoading}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <Button
                      className="mt-4 float-end rounded-pill btn-primary"
                      type="submit"
                      disabled={status !== AuctionStatus.PUBLISHED || isLoading}
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default VehicleAddBidForm;
